export enum ShowProperty {
  id = '_id',
  name = 'name',
  logo = 'logo',
  about = 'about',
  episodes = 'episodes',
  chatEnabled = 'chatEnabled',
}
